import { types, getParent, flow } from 'mobx-state-tree';
import { GeneralLedgerCodeRow } from './models';
import { resolvePaginationStore } from '../PaginationStore';

const GeneralLedgerCodesStore = types
  .model('GeneralLedgerCodesStore', {
    generalLedgerCodes: types.array(GeneralLedgerCodeRow),
    pagination: types.optional(
      resolvePaginationStore({
        onChangePerPage: (self) => getParent(self).loadGeneralLedgerCodes(),
        onChangePage: (self, page) => getParent(self).loadGeneralLedgerCodes({ page }),
      }),
      {
        perPage: 50
      },
    ),
  })
  .volatile(self => ({
    loading: false,
  }))
  .views(self => ({
    get root() {
      return getParent(self);
    },
  }))
  .actions(self => ({
    loadGeneralLedgerCodes: flow(function* ({ page = 1 } = {}) {
      try {
        self.loading = true;
        const response = yield self.root.api.generalLedgerCode.index({ page: page, per_page: self.pagination.perPage });
        self.generalLedgerCodes = response.data.data;
        self.pagination.setFromMeta(response.data.meta);
      } catch (error) {
        self.root.ui.toast.error(error);
      }
      self.loading = false;
    }),
    destroy: flow(function* (id) {
      if (window.confirm('Are you sure to delete it?')) {
        let response;
        try {
          self.loading = true;
          response = yield self.root.api.generalLedgerCode.destroy(id);
          self.loadGeneralLedgerCodes();
        } catch (error) {
          self.root.ui.toast.error(error);
        }
        self.loading = false;
      }
    }),
  }))


export default GeneralLedgerCodesStore;
